export const REFERRAL_INVITE_PARAMS = {
  token: 'token',
  referralId: 'referralId',
}
